export interface TimerInfo {
  status: TimerStatusType;
  seconds: string;
  minutes: string;
  hours: string;
  days: string;
}

export enum TimerStatusType {
  STARTING = 'starting',
  ACTIVE = 'active',
  ENDED = 'ended',
}

export enum PromoBackgroundModifiers {
  Blue = 'blue',
  Grey = 'grey',
  Red = 'red',
}

export enum CoBrandProms {
  DDW = 'DDW',
  Slotmania = 'IDNLCSM',
  BronzeBlackJack = 'BBJT',
  SilverBlackJack = 'SBJT',
  GoldBlackJack = 'GBJT',
  PrivateBlackJack = 'PRBJT',
}
